export default {
  base: '/tracking/embedded-widgets',
  start: '/tracking/embedded-widgets/start',
  create: '/tracking/embedded-widgets/create',
};